module.exports = __webpack_public_path__ + "media/marketing_campaigns/schedule-f809faf9.svg";